import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="toggle-hidden"
export default class extends Controller {
  static targets = [
    'elementShown',
    'elementHidden',
  ]

  declare readonly elementShownTargets: HTMLElement[]
  declare readonly elementHiddenTargets: HTMLElement[]

  static values = {
    startToggled: Boolean,
  }

  declare startToggledValue: boolean

  connect (): void {
    this.elementShownTargets.forEach(el => {
      el.classList.toggle('hidden', !this.startToggledValue)
    })
    this.elementHiddenTargets.forEach(el => {
      el.classList.toggle('hidden', this.startToggledValue)
    })
  }

  toggle = (): void => {
    this.elementShownTargets.concat(this.elementHiddenTargets).forEach(el => {
      el.classList.toggle('hidden')
    })
  }
}
